import { z } from 'zod';

export const ReturnPolicyTaskSchema = z.object({
  agree: z.boolean().refine((v) => v, 'You must agree to the return policy'),
});
